
import { Component, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { generalService } from '../../../services/general.service';

import { Cotizacion } from '../../../models/cotizacion';
import { MatPaginator,MatDialog, MatSort } from '@angular/material';
import { DataService } from '../../../utils/data.service';
import { CotizacionAddEditComponent } from '../agregar-editar/cotizacionAddEdit.component';
import { DataSourceGrid } from '../../../utils/data-source-grid.component';
@Component({
  selector: 'my-cotizacion',
  styleUrls: [],
  templateUrl: 'Cotizacion.component.html',
  providers: [generalService]
})


 export class CotizacionComponent implements OnInit {
titulo = '';

public datosCotizacion: Array<any>;
 public cotizacion: Cotizacion;
  displayedColumns = ['acciones', 'fecha', 'monto' , 'comentario'];
  dataSource: DataSourceGrid | null;
cliente_id: string;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private _generalService: generalService,
    public dataService: DataService,
    public dialog: MatDialog
    ) {
     this.cotizacion = new Cotizacion();
     this.cliente_id = (this.route.snapshot.paramMap.get('id'));
    // this.person_id = "1";
     this.datosCotizacion = new Array();
    // Usar en caso de emergencia con el router
    // this.router.events.subscribe(path => {
    //   console.log('path = ', path);
    // });
  }

  ngOnInit() {

    this.getCotizaciones(this.cliente_id);
    }

 @ViewChild(MatPaginator) paginator: MatPaginator;
 @ViewChild(MatSort) sort: MatSort;

    getCotizaciones(id: any) {

      this._generalService.metodoCall(`cotizacion/consultarCotizaciones/${id}`).subscribe(
        (result) => {

          this.datosCotizacion = JSON.parse(result);
          this.dataSource = new DataSourceGrid(this.datosCotizacion, this.paginator, this.sort);
          if (this.datosCotizacion.length <= 0) {
            $('#tableCotizacion .mat-row').remove('.mat-row');
          } else {
         this.dataService.dialogRef.renderRows();
            }
        },
        (error) => {
          let errorMsj =  error as any;
          console.log(errorMsj);
        }
      );
    }

     agregar() {
    this.dataService.tipo = 'agregar';
    const dialogRef = this.dialog.open(CotizacionAddEditComponent, {disableClose: true, width: '100%', maxWidth: '50%'});
    this.dataService.idCliente = this.cliente_id;
    this.dataService.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe((result) => {
      if (this.dataService.guardado) {
        this._generalService.toastCall('El registro se agregó exitosamente!');
        this.ngOnInit();

      }
    });
  }

   editar(idCotizacion) {
    this.dataService.id = idCotizacion;
    this.dataService.tipo = 'editar';
    this.dataService.idCliente = this.cliente_id;
    const dialogRef = this.dialog.open(CotizacionAddEditComponent, {disableClose: true, width: '100%', maxWidth: '50%'});
    this.dataService.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe((result) => {
      if (this.dataService.guardado) {
        this._generalService.toastCall('El registro se modificó exitosamente!');
        this.ngOnInit();
      }
    });
  }

    eliminarConfirm(data: any) {
    this.cotizacion.idCotizacion = data.idCotizacion;
    const eliminarHttp = new EventEmitter<any>();
    eliminarHttp.subscribe(
      (response: any) => {

           this._generalService.toastCall('El registro se eliminó exitosamente!');
           this.ngOnInit();

      }
    );
    this._generalService.modal(eliminarHttp, 'confirm', '¿Desea eliminar la cotizacion ' + data.monto + '?', 'cotizacion/eliminarCotizacion/', this.cotizacion);
  }
}

  // llenado de grid

/*export interface familiarData {
   idFamilar:number,
    nombre:string,
     paterno:string,
     materno:string,
     relacion:number,
     accion: number,
     nombreP: string,
     apellidoP: string
}

export class DataSourceGrid extends DataSource<any> {
  constructor(private result, private _paginator: MatPaginator, public _sort: MatSort) {
    super();
  }

  connect(): Observable<familiarData[]> {
    const displayDataChanges = [
      this.result,
      this._sort.sortChange,
      this._paginator.page,
    ];

    return Observable.merge(...displayDataChanges).map(() => {
      const data = this.result.slice();
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      const sortedData = this.sortData(data.slice());
      return sortedData.splice(startIndex, this._paginator.pageSize);
    });
  }

  disconnect() {}

  sortData(data: familiarData[]): familiarData[] {
    if (!this._sort.active || this._sort.direction == '') { return data; }
    return data.sort((a, b) => {
      let propertyA: number|string = '';
      let propertyB: number|string = '';
      [propertyA, propertyB] = [a[this._sort.active], b[this._sort.active]];
      let valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      let valueB = isNaN(+propertyB) ? propertyB : +propertyB;
      return (valueA < valueB ? -1 : 1) * (this._sort.direction == 'asc' ? 1 : -1);
    });
  }

}*/



// WEBPACK FOOTER //
// ./src/app/cliente/cotizacion/consultar-eliminar/cotizacion.component.ts